module.exports = __webpack_public_path__ + "static/NW_Lucas_Bild_Portr_1-c91645931943beb4cc9cae046f5e79b2.jpg";